export default __webpack_public_path__ + "static/canes-vault-470f4b331c82f1f5e4de2a3d628151f2.png";